import React from 'react';
import PropTypes from 'prop-types';
import { ManageScheduledPayment } from 'payments-lib';
import {
  GenericChatComponent,
  getChatContent,
} from '../common/GenericChatComponent';
import AccountsStore from '../../stores/AccountsStore';
import UserManagementStore from '../../stores/UserManagementStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import ManagePaymentsStore from '../../stores/ManagePaymentsStore';
import {
  getSelectedAccount,
  getAccountsToFilterOn,
  getSessionInfo,
  handleEdit,
  handleEditById,
} from './ManagePaymentsSMEUtils';
import ManagePaymentsSMERenderPicker from './ManagePaymentsSMERenderPicker';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import FavouritesActionCreator from '../../actions/AccountsActionCreator/FavouritesActionCreator';
import envConfig from '../../../static/config';

class ManagePaymentsSME extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccountId: AccountsStore.getAccount(),
    };
    this.onStoreChange = this.onStoreChange.bind(this);
  }

  componentDidMount() {
    AccountsStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    FavouritesActionCreator.clearSelectedAccountId();
    AccountsStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange() {
    this.setState({ selectedAccountId: AccountsStore.getAccount() });
  }

  render() {
    const { session, content } = this.props;

    const backUrl = ManagePaymentsStore.getBackUrl();
    const user = UserManagementStore.getCADetails();
    const sessionInfo = getSessionInfo(session);

    return (
      <div className="page">
        <ManageScheduledPayment
          accounts={getAccountsToFilterOn(this.state.selectedAccountId)}
          session={sessionInfo}
          envConfig={envConfig}
          user={user}
          handleEdit={handleEdit}
          handleEditById={handleEditById}
          handleBack={() => InternetBankingActions.navigateToWebTask(backUrl)}
          chatBox={<GenericChatComponent content={getChatContent(content)} />}
          renderPicker={(props) => (
            <ManagePaymentsSMERenderPicker
              dropDownProps={props}
              selectedAccountId={this.state.selectedAccountId}
              content={content}
            />
          )}
          showPaymentDetail={
            !FavouritesStore.isLargeCustomer() || this.state.selectedAccountId
          }
          accountPickerSelectedAccount={getSelectedAccount(
            this.state.selectedAccountId
          )}
          totalNumberOfAccounts={FavouritesStore.getTotalNumberOfAccounts()}
        />
      </div>
    );
  }
}

ManagePaymentsSME.propTypes = {
  session: PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
  }).isRequired,
  content: PropTypes.shape({
    chatHeading: PropTypes.string.isRequired,
  }),
};

export default ManagePaymentsSME;
